<template>
  <v-footer class="mt-2" color="primary lighten-1" padless elevation="2">
    <v-row justify="center" no-gutters>
      <!-- <v-btn
        v-for="(link, name) in links"
        :key="name"
        color="white"
        text
        rounded
        class="my-2"
      >
        <a class="white--text" :href="link" target="_blank">{{ name }}</a>
      </v-btn> -->
      <v-col
        class="
          white
          py-4
          text-center
          primary--text
          d-flex
          flex-column
          justify-space-between
          align-center
        "
        cols="12"
      >
        <!-- {{ new Date().getFullYear() }} -->
        <v-img
          alt="Dutch Bros"
          class="shrink mr-2"
          contain
          src="https://files.dutchbros.com/logos/primary_logo_blue_text.png"
          transition="scale-transition"
          width="150"
        />
      </v-col>
      <v-col class="white text-center">
        <v-btn
          v-for="(link, name) in links"
          :key="name"
          color="primary"
          text
          rounded
          class="my-2"
        >
          <a
            class="primary--text text-decoration-none font-weight-bold"
            :href="link"
            target="_blank"
            >{{ name }}</a
          >
        </v-btn>
      </v-col>
      <v-col
        class="caption white lighten-2 py-4 px-12 text-center primary--text"
        cols="12"
      >
        <div>
          Dutch Bros is a equal opportunity employer. By using this website you
          agree to our
        </div>
        <a
          class="primary--text text-decoration-none font-weight-bold"
          href="https://www.dutchbros.com/terms-of-service/"
          target="_blank"
        >
          Terms of Service</a
        >,
        <a
          :to="{ name: 'Privacy Rights Notice' }"
          class="primary--text text-decoration-none font-weight-bold"
          href="https://www.dutchbros.com/privacy-rights-notice"
          target="_blank"
        >
          Privacy Rights Notice</a
        >,
        <a
          class="primary--text text-decoration-none font-weight-bold"
          href="https://dutchbros.com/privacy-policy"
          target="_blank"
        >
          Privacy Policy</a
        >, and
        <router-link
          :to="{ name: 'Employment Notices' }"
          class="primary--text text-decoration-none font-weight-bold"
          target="_blank"
        >
          Employment Notices
        </router-link>
      </v-col>
    </v-row>
  </v-footer>
</template>


<script>
export default {
  name: "Footer",
  data: () => ({
    links: {
      Home: "https://dutchbros.com",
      "Becoming a Broista":
        "https://www.dutchbros.com/employment/become-a-broista",
      "Contact Us": "https://www.dutchbros.com/support/",
      "Accessibility Statement": "https://www.dutchbros.com/digital-accessibility",
    },
  }),
  computed: {
    app_state: {
      get() {
        return this.$store.state;
      },
    },
  },
};
</script>